// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// Imagess
import planes from '../../sass/images/ilustracion-planes.svg';
import pin from '../../sass/images/pin2.svg';

// Components
import Template from '../components/Template';

// Utils
import { contactEmail } from '../helpers';

function Plans({ t }) {
  return (
    <Template
      component="plans"
      type={2}
      classNameContainer="plans"
      className="container_menu plans"
    >
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12 img-plan">
          <img className="img-plan" src={planes} alt={t('alt:plans_ilustration')} />
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 text-plan">
          <h1>{t('tittle')}</h1>
          <hr className="spacy-x1" />
          <h2>{t('text1')}</h2>
          <hr className="spacy-x2" />
          <p className="txt-plan">{t('text2')}</p>
          <hr className="spacy-x2" />
          <p className="txt-plan-cursive">
            {t('text3')}
            <b>
              <a href={`mailto:${contactEmail()}`}>
                <strong>{`${contactEmail()} `}</strong>
              </a>
            </b>
            {t('text4')}
          </p>
          <div className="grid-imag">
            <img src={pin} alt={t('alt:location')} />
          </div>
        </div>
      </div>
    </Template>
  );
}

Plans.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation(['plans', 'alt'])(Plans);
